export default __webpack_public_path__ + "static/media/img6.c7390ed7.jpg";